import convertToText from "./convert_to_text.js"
import convertLineBreaks from "./convert_line_breaks.js"
import { escape } from "html-escaper"

const sanitizePastedText = (str = "") => {
  if (!str) return
  let value = String(str)
  value = escape(value)
  return value
}

const sanitizeIncomingText = (str = "") => {
  if (!str) return
  let value = String(str)
  value = escape(value)
  value = decodeURIComponent(value)
  value = convertLineBreaks(value)
  return value
}

const sanitizeOutgoingText = (str = "") => {
  if (!str) return
  let value = String(str)
  value = encodeURIComponent(value)
  value = convertToText(value)
  return value
}

export { sanitizePastedText, sanitizeIncomingText, sanitizeOutgoingText }
